const initialState = {
    submissions: [],
    loading: false,
    error: null,
    updateLoading: false,
    updateSuccess: false,
    updateError: null,
};

export const consultantReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'FETCH_SUBMISSIONS_REQUEST':
            return { ...state, loading: true, error: null };
        case 'FETCH_SUBMISSIONS_SUCCESS':
            return { ...state, loading: false, submissions: action.payload };
        case 'FETCH_SUBMISSIONS_FAILURE':
            return { ...state, loading: false, error: action.payload };
        
        case 'UPDATE_SUBMISSION_STATUS_REQUEST':
            return { ...state, updateLoading: true, updateSuccess: false, updateError: null };
        case 'UPDATE_SUBMISSION_STATUS_SUCCESS':
            return { ...state, updateLoading: false, updateSuccess: true };
        case 'UPDATE_SUBMISSION_STATUS_FAILURE':
            return { ...state, updateLoading: false, updateError: action.payload };
            
        default:
            return state;
    }
};
